<admin-app-header></admin-app-header>

<div class="container-fluid data-hygiene-page">
    <div class="d-flex justify-content-between align-items-start mb-4">
        <div>
            <h1><i class="fa-solid fa-broom me-2"></i>Data Hygiene</h1>
            <p class="text-muted mb-0">Housekeeping flags across invoices, payouts, CRM, and parkings.</p>
        </div>
        <div class="d-flex align-items-center gap-3">
            <select class="form-select form-select-sm enterprise-select" (change)="onEnterpriseChange($any($event.target).value)">
                <option value="">All Enterprises</option>
                <option *ngFor="let e of enterprises" [value]="e.key">{{ e.name }}</option>
            </select>
            <button class="btn btn-sm btn-outline-secondary" (click)="loadAllIssues()" [disabled]="isLoading">
                <i class="fa-solid fa-arrows-rotate" [class.fa-spin]="isLoading"></i> Refresh
            </button>
        </div>
    </div>

    <!-- Loading -->
    <div *ngIf="isLoading" class="text-center py-5">
        <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
        <p class="text-muted mt-2">Scanning for issues...</p>
    </div>

    <ng-container *ngIf="!isLoading">
        <!-- Summary cards -->
        <div class="row g-3 mb-4">
            <div class="col-6 col-md-3">
                <div class="summary-card summary-card--invoice" [class.active]="selectedType === 'invoice'" (click)="onTypeFilter(selectedType === 'invoice' ? null : 'invoice')">
                    <div class="summary-card__count">{{ counts.invoice }}</div>
                    <div class="summary-card__label">Customer Invoices</div>
                </div>
            </div>
            <div class="col-6 col-md-3">
                <div class="summary-card summary-card--payout" [class.active]="selectedType === 'payout'" (click)="onTypeFilter(selectedType === 'payout' ? null : 'payout')">
                    <div class="summary-card__count">{{ counts.payout }}</div>
                    <div class="summary-card__label">Merchant Payouts</div>
                </div>
            </div>
            <div class="col-6 col-md-3">
                <div class="summary-card summary-card--crm" [class.active]="selectedType === 'crm'" (click)="onTypeFilter(selectedType === 'crm' ? null : 'crm')">
                    <div class="summary-card__count">{{ counts.crm }}</div>
                    <div class="summary-card__label">CRM Issues</div>
                </div>
            </div>
            <div class="col-6 col-md-3">
                <div class="summary-card summary-card--parking" [class.active]="selectedType === 'parking'" (click)="onTypeFilter(selectedType === 'parking' ? null : 'parking')">
                    <div class="summary-card__count">{{ counts.parking }}</div>
                    <div class="summary-card__label">Parking Issues</div>
                </div>
            </div>
        </div>

        <!-- Type filter pills -->
        <div class="d-flex gap-2 mb-3 flex-wrap">
            <button class="btn btn-sm" [class.btn-dark]="!selectedType" [class.btn-outline-secondary]="selectedType" (click)="onTypeFilter(null)">
                All ({{ totalIssues }})
            </button>
            <button class="btn btn-sm" [class.btn-danger]="selectedType === 'invoice'" [class.btn-outline-danger]="selectedType !== 'invoice'" (click)="onTypeFilter(selectedType === 'invoice' ? null : 'invoice')">
                Customer Invoices ({{ counts.invoice }})
            </button>
            <button class="btn btn-sm" [class.btn-warning]="selectedType === 'payout'" [class.btn-outline-warning]="selectedType !== 'payout'" (click)="onTypeFilter(selectedType === 'payout' ? null : 'payout')">
                Payouts ({{ counts.payout }})
            </button>
            <button class="btn btn-sm" [ngClass]="selectedType === 'crm' ? 'btn-crm-active' : 'btn-crm'" (click)="onTypeFilter(selectedType === 'crm' ? null : 'crm')">
                CRM ({{ counts.crm }})
            </button>
            <button class="btn btn-sm" [class.btn-primary]="selectedType === 'parking'" [class.btn-outline-primary]="selectedType !== 'parking'" (click)="onTypeFilter(selectedType === 'parking' ? null : 'parking')">
                Parking ({{ counts.parking }})
            </button>
        </div>

        <!-- No issues -->
        <div *ngIf="filteredIssues.length === 0" class="text-center py-5">
            <i class="fa-solid fa-circle-check text-success" style="font-size: 3rem"></i>
            <h4 class="mt-3">No issues found</h4>
            <p class="text-muted">Everything looks clean{{ selectedEnterprise ? ' for this enterprise' : '' }}{{ selectedType ? ' in this category' : '' }}.</p>
        </div>

        <!-- Issues table -->
        <div *ngIf="filteredIssues.length > 0" class="table-responsive">
            <table class="table table-hover table-striped align-middle">
                <thead class="table-light">
                    <tr>
                        <th>Type</th>
                        <th>Entity</th>
                        <th>Issue</th>
                        <th>Details</th>
                        <th class="text-end">Age</th>
                        <th class="text-end">Amount</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let issue of filteredIssues">
                        <td>
                            <span class="badge type-badge" [ngClass]="getTypeBadgeClass(issue.type)">{{ getTypeLabel(issue.type) }}</span>
                            <br>
                            <small class="text-muted">{{ issue.subType }}</small>
                        </td>
                        <td class="fw-medium">{{ issue.entity }}</td>
                        <td>{{ issue.issue }}</td>
                        <td><small class="text-muted">{{ issue.details }}</small></td>
                        <td class="text-end text-nowrap">
                            <span *ngIf="issue.ageDays !== null" [class.text-danger]="issue.ageDays > 60" [class.text-warning]="issue.ageDays > 30 && issue.ageDays <= 60">
                                {{ issue.ageDays }}d
                            </span>
                            <span *ngIf="issue.ageDays === null" class="text-muted">-</span>
                        </td>
                        <td class="text-end text-nowrap">
                            <span *ngIf="issue.amount !== null">{{ formatCurrency(issue.amount) }}</span>
                            <span *ngIf="issue.amount === null" class="text-muted">-</span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </ng-container>
</div>
